import {request} from './request';


export async function getAirlines()
{
    const rv = await request({
        url: '/api/data/airlines',
        method: 'get'
    });

    return rv;
}

export async function calculateCompensation(data)
{
    const rv = await request({
        url: '/api/flights/compensation-external',
        method: 'post',
        data: data
    });

    return rv;
}

export async function createNewCase(caseData)
{
    const rv = await request({
        url: '/api/flights/create-external',
        method: 'post',
        data: caseData
    });

    return rv;
}